import styled from 'styled-components';
import { Radio as AntdRadio } from 'antd';
import { COLORS } from '@/theme';

export const StyledRadio = styled(AntdRadio)`
  &&& {
    .ant-radio-checked {
      .ant-radio-inner {
        border-color: ${COLORS.ORANGE_PRIMARY};
        background-color: ${COLORS.WHITE};
      }

      .ant-radio-inner::after {
        background-color: ${COLORS.ORANGE_PRIMARY};
      }
    }

    &:hover {
      .ant-radio-inner {
        border-color: ${COLORS.ORANGE_PRIMARY};
      }
    }

    .ant-radio-disabled {
      &:hover {
        .ant-radio-inner {
          border-color: ${COLORS.GREY_SUVA};
        }
      }
    }
  }
`;
